import httpClient from '@/lib/httpClient.js'
import { useQuery } from '@tanstack/react-query'

export default function useGetVaults({
  offset,
  numberOfPeriods,
  periodType,
} = {}) {
  const fetchData = async () => {
    const response = await httpClient.get('team/cash-flow/vaults', {
      params: {
        o: offset,
        c: numberOfPeriods,
        p: periodType,
      },
    })
    return response.data.data
  }

  return useQuery({
    // queryKey: ['names-column', offset, numberOfPeriods, periodType],
    queryKey: ['vaults', 'list', { offset, numberOfPeriods, periodType }],
    queryFn: fetchData,
    staleTime: Infinity,
    // enabled: isAuthenticated,
  })
}
